(function(){

  const form = document.getElementById('contact-form');

  if(!form) return false;

    const SITE_KEY = '6LdmMcAUAAAAAB_weD4FTeC7-SEkoxM-Kq20SxK4';
    const submit = document.getElementById('contact-form-submit');
    submit.disabled = true;

    grecaptcha.ready(function() {
      try{
        grecaptcha.execute(SITE_KEY, {action: 'submitMoriroboForm' })
        .then(function(token) {
          submit.disabled = false;
          var recaptchaResponse = document.getElementById("recaptchaResponse");
          recaptchaResponse.value = token;
        }, function(reason) {
          alert("エラーが発生しました。");
        });
      }catch(e){
        alert("エラーが発生しました。");
      }
    });

})();
